import { isAllowedLinkHost } from './allowedLinkDomains';
import { hostMatchesDomain } from './hostMatchesDomain';

// The rule for any URL in a bot answer, links and images alike, so a bypass fixed here is fixed for
// both. Resolving against the page, as the browser does, settles protocol-relative, slash-less and
// percent-encoded hosts the same way it will.
export function isAllowedAnswerUrl(url: string, pageUrl: string, extraHosts: readonly string[] = []): boolean {
    let resolved: URL;
    try {
        resolved = new URL(url, pageUrl);
    } catch {
        return false;
    }

    if (resolved.origin === new URL(pageUrl).origin) {
        return true;
    }

    return (
        (resolved.protocol === 'https:' || resolved.protocol === 'http:') &&
        (isAllowedLinkHost(resolved.hostname) || hostMatchesDomain(resolved.hostname, extraHosts))
    );
}

/** The part of a rehype (hast) node the answer plugins read and rewrite. */
export interface HastNode {
    type: string;
    tagName?: string;
    value?: string;
    properties?: Record<string, unknown>;
    children?: HastNode[];
}
